import React from 'react';
import '../../../../styles/Header.css';
import PropTypes from 'prop-types';

const Header = ({ children }) => {
  return (
    <div className="rlHeader">
      <div className="wrapper">{children}</div>
    </div>
  );
};

Header.propTypes = {
  children: PropTypes.any
};

export default Header;
